import React from 'react';
import usePageTitle from '../hooks/usePageTitle';

const Press = () => {
    usePageTitle("Press | Dinara Fariz");

    return (
        <div className="max-w-5xl mx-auto px-2 md:px-6 pt-6 md:pt-10 pb-0 text-center">
            <h1 className="text-2xl md:text-4xl uppercase tracking-[0.25em] mb-6">
                Instagram
            </h1>

            <p className="text-gray-600 text-sm md:text-base mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
                Moments from my work, studio and exhibitions.
                Follow me on Instagram for more updates.
            </p>

            <a
                href="https://www.instagram.com/dinarafar/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mb-6 md:mb-10 text-sm uppercase tracking-[0.2em] border border-gray-400 px-4 md:px-6 py-2 hover:bg-black hover:text-white transition"
            >
                Open Instagram
            </a>

            <div className="w-full max-w-4xl mx-auto">
                <div className="relative w-full overflow-hidden min-h-[360px] md:min-h-[860px]">
                    <iframe
                        title="Instagram Feed"
                        src="https://cdn.lightwidget.com/widgets/833d49b404cc5922b62397f333cd6d23.html"
                        scrolling="no"
                        allowTransparency={true}
                        className="lightwidget-widget w-full absolute top-0 left-0"
                        style={{
                            border: 0,
                            overflow: 'hidden',
                            height: '100%',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Press;